module.exports = __webpack_public_path__ + "img/class_card_default_bg.ed4b2159.png";